<template>
    <div>
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless class="list">
            <b-thead>
                <b-tr>
                    <b-th style="width: 10%;">Date:</b-th>
                    <b-th style="width: 5%;">Type:</b-th>
                    <b-th style="width: 15%;">Patient:</b-th>
                    <b-th style="width: 30%;">Communication:</b-th>
                    <b-th style="width: 13%;">Reference:</b-th>
                    <b-th style="width: 10%;">Add By:</b-th>
                    <b-th style="width: 10%;">Status:</b-th>
                    <b-th style="width: 7%;"></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(comm, i) in comms" :key="i">
                    <b-td>
                        {{ _carbonDateTimeDisplay(comm.date) }}
                        <input type="hidden" name="id" :value="comm.id" />
                    </b-td>
                    <b-td class="text-capitalize">
                        {{ commTypeTitle(comm) }}
                    </b-td>
                    <b-td class="word-break">
                        <patient-name
                            :use-router="USE_PATIENT_MODULE_VUE"
                            v-if="comm.patient"
                            :patient="comm.patient"
                        />
                        <span v-else></span>
                    </b-td>
                    <b-td class="word-break">
                        <html-content
                            :isReplaceNewLine="comm.type !== 4"
                            :content="formatContent(comm.content)"
                            :expanded="currentExpandedCommId === comm.id"
                            :maxWidth="650"
                            @onClickSeeMore="() => expandContent(comm.id)"
                            @onClickSeeLess="() => expandContent(null)"
                        />
                    </b-td>

                    <b-td>
                        <a
                            v-if="comm.reference"
                            :href="CI_APPS + comm.reference.ci_url"
                            target="_blank"
                        >
                            {{ comm.reference.title }}
                        </a>
                        <div v-html="extractBccAttachment(comm.content)"></div>
                    </b-td>
                    <b-td>
                        {{ comm.create_by ? comm.create_by.label : null }}
                    </b-td>
                    <b-td>
                        <span v-if="comm.status === 'Send'">
                            <i class="cus-email-go"></i> Sent
                        </span>
                        <span v-else-if="comm.status === 'Delivery'">
                            <i class="cus-email-go"></i> Delivered
                        </span>
                        <span v-else-if="comm.status === 'Open'">
                            <i class="cus-email-open"></i> Opened
                        </span>
                        <span v-else-if="comm.status === 'Click'">
                            <i class="cus-email-link"></i> Clicked
                        </span>
                        <span
                            v-else-if="comm.status === 'Bounce'"
                            v-b-tooltip.hover
                            :title="comm.smtp_error"
                        >
                            <i class="cus-email-error"></i> Failed
                        </span>
                        <span v-else-if="comm.status === 'renderingFailure'">
                            <i class="cus-email-error"></i> Rendering Failed
                        </span>
                        <span v-else-if="comm.status === 'Complaint'">
                            <i class="cus-email-delete"></i> Complaint
                        </span>
                        <span v-else-if="comm.status === 'Reject'">
                            <i class="cus-email-delete"></i> Rejected
                        </span>
                    </b-td>
                    <b-td class="options">
                        <!-- delete & edit -->
                        <b-dropdown
                            v-if="comm.iseditable"
                            size="sm"
                            variant="link"
                            right
                            no-caret
                        >
                            <template v-slot:button-content>
                                <i class="cus-cog-down"></i>
                            </template>
                            <b-dropdown-item @click="editCommunication(comm)">
                                <i class="cus-page-white-edit"></i>
                                Edit Communication
                            </b-dropdown-item>
                            <b-dropdown-item @click="promptDelete(comm.id)">
                                <i class="cus-delete"></i>
                                Delete Communication
                            </b-dropdown-item>
                        </b-dropdown>
                        <!-- delete for not editable comm -->
                        <b-button
                            v-if="!comm.iseditable"
                            right
                            variant="link"
                            size="sm"
                            class="p-0"
                            @click="promptDelete(comm.id)"
                        >
                            <i class="cus-delete"></i>
                        </b-button>
                    </b-td>
                </b-tr>
                <b-tr v-if="comms.length === 0">
                    <b-td colspan="8">
                        <i>No records available</i>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-pagination
            v-if="showPagination"
            class="vet-pagination"
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="changePage"
        />

        <modal-delete ref="modalDelete" @onSuccess="afterDeleted" />
    </div>
</template>

<script>
import ContactCommunication from "@/services/contact-communications";
import Loader from "@/components/elements/loader-list";
import ModalDelete from "@/components/communication/communication-delete-modal";
import PatientName from "@/components/commons/patient-name";
import HtmlContent from "@/components/commons/html-content";
import CommunicationHelper from "@/module/communication/helper"; // helper

export default {
    mixins: {
        CommunicationHelper
    },
    components: {
        Loader,
        ModalDelete,
        PatientName,
        HtmlContent
    },
    props: {
        listType: {
            type: String,
            default: "all"
        }
    },
    data() {
        return {
            comms: [],
            resultMeta: {},
            isLoading: false,
            isLoadingPrintRecordId: false,
            CI_APPS: process.env.CI_APPS,
            currentPage: 1,
            totalRows: 0,
            perPage: 0,
            showPagination: false,
            currentExpandedCommId: null
        };
    },
    computed: {
        userId() {
            return this.$route.params.id;
        },
        contactId() {
            return this.$store.state.contact.contactId;
        },
        isCompany() {
            return this.$route.name === "contact_company";
        },
        contactType() {
            return this.isCompany ? "business" : "actor";
        }
    },
    mounted() {
        this.getCommunications(1);
    },
    methods: {
        async getCommunications(page) {
            this.isLoading = true;

            let res = await ContactCommunication.getCommunications(
                this.contactId,
                this.contactType,
                page
            );
            let { meta, resources } = res;

            this.resultMeta = meta;
            this.comms = resources;
            this.isLoading = false;

            // update pagination details
            this.currentPage = meta.currentPage;
            this.totalRows = meta.total;
            this.perPage = meta.perPage;
            this.showPagination = meta.lastPage > 1;
        },
        changePage(nextPage) {
            this.getCommunications(nextPage);
        },
        promptDelete(recordId) {
            this.$refs.modalDelete.open(recordId);
        },
        afterDeleted() {
            this.getCommunications();
        },
        editCommunication(comm) {
            this.$root.$emit(
                "open-modal-contact",
                "modalLogCommunication",
                comm
            );
        },
        expandContent(commId) {
            this.currentExpandedCommId = commId;
        }
    }
};
</script>

<style scoped>
td.options {
    width: 50px;
    text-align: right;
}
.word-break {
    word-break: break-all;
}
</style>
